import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { LoaderEvent } from './../../shared/message.event';
import { FeedbackService } from './../feedback.service';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { UtilityFunctions } from '../../shared/utility-functions';
@Component({
    selector: 'app-feedback-forward',
    templateUrl: './feedback-forward.component.html',
    styleUrls: ['./feedback-forward.component.css'],
    providers: [LoaderEvent],
    exportAs: 'feedbackForword'
})
export class FeedbackForwardComponent implements OnInit {
    private popUpMessage = '';
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Input() cancleButton;
    @Output() notify = new EventEmitter<boolean>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    @Input() deleteMessage;
    @Input() tempFacilityId;
    public onsamePage = 0;
    @Output() facilityid = new EventEmitter<string>();
    private memberData = {};
    private forword = {
        emailIds: [],
        subject: '',
        comments: ''
    }
    private validate = {
        recipants: '',
        subject: '',
        comments: ''
    };
    private recipants = '';
    private utilityFunctions = new UtilityFunctions();

    constructor(private loaderEvent: LoaderEvent, private feedbackService: FeedbackService, private appService: AppService) {
    }

    public showChildModal(item): void {
        try {
            this.memberData = item;
            this.validate.recipants = '';
            this.validate.comments = '';
            this.forword.emailIds = [];
            this.recipants = '';
            this.forword.subject = this.memberData['subActivity'];
            this.forword.comments = '';
            this.childModal.config.backdrop = false;
            this.childModal.show();
        } catch (e) {
            console.log(e);
        }
    }

    public hideChildModal(): void {
        try {
            this.childModal.hide();
        } catch (e) {
            console.log(e);
        }
    }

    ngOnInit() {
    }
    /**
     * API call to forward the feedback
     * 
     * @param {any} popup 
     * 
     * @memberof FeedbackForwardComponent
     */
    onClickSend(popup) {
        if (this.validationOfForword('')) {
            let forword = {
                'feedbackId': this.memberData['_id'],
                'emailIds': this.forword.emailIds,
                'comments': this.forword.comments,
                'subject': this.forword.subject,
                'activity': this.memberData['activity'],
                'subActivity': this.memberData['subActivity']
            }
            this.loaderEvent.fire(false);
            this.feedbackService.feedbackFOrword(forword).then((result: any) => {
                if (result.status === 'SUCCESS') {
                }
                this.loaderEvent.fire(true);
                this.popUpMessage = result.message;
                this.hideChildModal();
                popup.showChildModal();
            }).catch((err) => {
                console.log(err);
                this.loaderEvent.fire(true);
            });
        }
    }
    /**
     * Hide popup on cancel
     * 
     * 
     * @memberof FeedbackForwardComponent
     */
    onClickCancle() {
        try {
            this.hideChildModal();
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Validate fields to be form
     * 
     * @param {any} para 
     * @returns 
     * 
     * @memberof FeedbackForwardComponent
     */
    validationOfForword(para) {
        let flag = true;
        switch (para) {
            case 'recipants':
                if (!this.recipants || !this.multipleEmailId()) {
                    this.validate.recipants = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.recipants = '';
                }
                break;
            case 'subject':
                if (!this.forword.subject) {
                    this.validate.subject = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.subject = '';
                }
                break;
            case 'comments':
                if (!this.forword.comments) {
                    this.validate.comments = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.comments = '';
                }
                break;
            default:
                if (!this.recipants || !this.multipleEmailId()) {
                    this.validate.recipants = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                }
                if (!this.forword.subject) {
                    this.validate.subject = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                }
                if (!this.forword.comments.trim()) {
                    this.validate.comments = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                }
                break;
        }
        return flag;
    }
    /**
     * Validation for multiple email id
     * 
     * @returns 
     * 
     * @memberof FeedbackForwardComponent
     */
    multipleEmailId() {
        let multipleRecipants = [];
        let validEmailFlag = true;
        multipleRecipants = this.recipants.split(',');
        for (let rec of multipleRecipants) {
            multipleRecipants[multipleRecipants.indexOf(rec)] = (rec + '').trim();
            validEmailFlag = this.utilityFunctions.validateEmail(multipleRecipants[multipleRecipants.indexOf(rec)]);
            if (!validEmailFlag) {
                break;
            }
        }
        if (validEmailFlag) {
            this.forword.emailIds = multipleRecipants;
        }
        return validEmailFlag;
    }
}



// WEBPACK FOOTER //
// ./src/app/feedback/feedback-forward/feedback-forward.component.ts